export default [{
    dictKey: '',
    dictValue: '全部'
}, {
    dictKey: '0',
    dictValue: '待退款'
}, {
    dictKey: '1',
    dictValue: '退款中'
},{
    dictKey: '2',
    dictValue: '退款成功'
},{
    dictKey: '3',
    dictValue: '退款失败'
}];



// WEBPACK FOOTER //
// ./src/service/constant/RefundStatus.js